import { render } from "./ImportUserForm.vue?vue&type=template&id=61f48b5e&ts=true"
import script from "./ImportUserForm.vue?vue&type=script&lang=ts"
export * from "./ImportUserForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__